import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import RecurrentPaymentContext from "../../../../../infrastructure/Contexts/components/data/RecurrentPaymentsWrapper/context";
import AcceptEducationStep1 from "./components/AccepEducationStep1";
import AcceptEducationStep2 from "./components/AcceptEducationStep2";

export default function AcceptEducationModal(): JSX.Element {
  const {
    recurrentPaymentDetail: { approvals },
  } = useContext(RecurrentPaymentContext);

  return (
    <Grid container item xs={12} direction="column">
      {approvals.length === 0 ? (
        <AcceptEducationStep1 />
      ) : (
        <AcceptEducationStep2 />
      )}
    </Grid>
  );
}
